'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _browserDetectionService = require('./browserDetectionService');

var _browser = require('../../../utils/services/browser');

var _BrowserWarning = require('./BrowserWarning');

var _BrowserWarning2 = _interopRequireDefault(_BrowserWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Utils


// Components


var BrowserDetection = function (_React$Component) {
    _inherits(BrowserDetection, _React$Component);

    function BrowserDetection() {
        _classCallCheck(this, BrowserDetection);

        var _this = _possibleConstructorReturn(this, (BrowserDetection.__proto__ || Object.getPrototypeOf(BrowserDetection)).call(this));

        _this.state = {
            supportedBrowser: false,
            acknowledgement: false,
            features: {
                isValid: true,
                errors: []
            }
        };

        _this.acknowledgeUnsupportedBrowser = _this.acknowledgeUnsupportedBrowser.bind(_this);
        return _this;
    }

    _createClass(BrowserDetection, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var supportedBrowser = (0, _browserDetectionService.isSupportedBrowser)();
            var requiredFeatureValidationResult = (0, _browserDetectionService.validateRequiredFeatures)();

            var acknowledgement = false;
            if (!supportedBrowser || !requiredFeatureValidationResult.isSupported) {
                acknowledgement = (0, _browserDetectionService.getBrowserUnsupportedAcknowledgement)();
            }

            this.setState({
                supportedBrowser: supportedBrowser,
                acknowledgement: acknowledgement,
                features: requiredFeatureValidationResult
            });

            if ((0, _browser.isSafari)()) this.setBodyClass('safari');
            if ((0, _browser.isMobile)()) this.setBodyClass('touch-device');
        }
    }, {
        key: 'setBodyClass',
        value: function setBodyClass(className) {
            document.body.classList.add(className);
        }
    }, {
        key: 'acknowledgeUnsupportedBrowser',
        value: function acknowledgeUnsupportedBrowser() {
            // Save the decision to local storage so they don't keep on getting asked on page refresh
            (0, _browserDetectionService.setBrowserUnsupportedAcknowledgement)();
            // Save the decision to state so they are presented with the workspace / login page
            this.setState({ acknowledgement: true });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                supportedBrowser = _state.supportedBrowser,
                features = _state.features,
                acknowledgement = _state.acknowledgement;


            return _react2.default.createElement(_BrowserWarning2.default, {
                acknowledgeUnsupportedBrowser: this.acknowledgeUnsupportedBrowser,
                supportedBrowser: supportedBrowser,
                features: features,
                acknowledgement: acknowledgement });
        }
    }]);

    return BrowserDetection;
}(_react2.default.Component);

BrowserDetection.propTypes = {
    children: _propTypes2.default.element
};

exports.default = BrowserDetection;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/browserSupport/BrowserDetection.js
// module id = 1760
// module chunks = 0